module.exports = __webpack_public_path__ + "img/143ne.f0c346be.svg";